module.exports = __webpack_public_path__ + "static/media/53 - Logo UGM.2bad2ede.jpg";